import {
  Box,
  Button,
  Divider,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSWRConfig } from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';
import PriorityFlag from '../utils/common/PriorityFlag.jsx';
import TicketTypeIcon from '../utils/common/TicketTypeIcon.jsx';
import UserAssignmentAutocomplete from '../utils/common/UserAssignmentAutocomplete.jsx';
import { setSnackBar } from '../../states/app/staticSlice.js';
import { useDispatch } from 'react-redux';

const TicketList = ({ profile, ticket, refetchUserStats }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedUser, setSelectedUser] = useState(ticket?.assignedTo);
  const { mutate: mutateUsers } = useSWRConfig();

  useEffect(() => {
    if (selectedUser?._id != ticket?.assignedTo?._id) {
      AxiosConfig.create('post', `/tickets/${ticket?._id}/assignUser`)
        .call({
          assignedBy: profile?._id,
          assignedTo: selectedUser?._id,
        })
        .exit((_res) => {
          mutateUsers(`${import.meta.env.VITE_API_URL}/api/users/`);
          const messageError = `L&apos;utilisateur a bien été assigné!`;
          dispatch(
            setSnackBar({ open: true, message: messageError, color: 'success' })
          );
          refetchUserStats();
        })
        .catch((err) => console.error(err));
    }
  }, [selectedUser]);

  const handleNavigateToProject = (projectId, ticketId) => {
    navigate(`/project/${projectId}/tickets/${ticketId}/activities`);
  };

  return (
    <TableRow>
      <TableCell>
        <Button
          variant="outlined"
          size="small"
          onClick={(_e) =>
            handleNavigateToProject(ticket?.project?._id, ticket?._id)
          }
        >
          {ticket?.reference}
        </Button>
      </TableCell>
      <TableCell>{ticket?.order ? ticket?.order?.reference : 'N/A'}</TableCell>
      <TableCell>{ticket?.contact?.email}</TableCell>
      <TableCell>
        {ticket?.contact?.store ? ticket?.contact?.store?.shortName : 'Inconnu'}
      </TableCell>
      <TableCell>
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            height: '100%',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <TicketTypeIcon
            ticketType={ticket?.ticketType?.name}
            service={ticket?.service?.code}
          />
        </Box>
      </TableCell>
      <TableCell>
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            height: '100%',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <PriorityFlag priority={ticket?.priority?.name} />
        </Box>
      </TableCell>
      <TableCell align="center">{ticket?.messagesCount}</TableCell>
      <TableCell>
        <Box
          sx={{
            width: '121px',
            height: '110px',
          }}
        >
          <Typography
            component={'p'}
            sx={{
              fontSize: '0.9rem',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              height: '100%',
            }}
          >
            <Tooltip
              placement="left"
              title={
                <Box>
                  {new Date(ticket?.message?.sentAt).toLocaleString('fr-FR', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                  })}
                  <Divider />
                  <Typography
                    component={'span'}
                    sx={{
                      fontSize: '0.7rem',
                      whiteSpace: 'break-spaces',
                    }}
                  >
                    <span>{ticket?.message?.snippet}</span>
                  </Typography>
                </Box>
              }
            >
              {ticket?.message?.snippet}
            </Tooltip>
          </Typography>
        </Box>
      </TableCell>
      <TableCell>
        <UserAssignmentAutocomplete
          assignmentId={ticket?.assignedTo}
          type={'ticket'}
          setSelectedUser={setSelectedUser}
          selectedUser={selectedUser}
          isSubmit={false}
        />
      </TableCell>
    </TableRow>
  );
};

export default TicketList;
